import { gql } from '@apollo/client';
/**
 * @fragment ContactPhoneFragment
 * @since 1.0.0
 */
export const ContactPhoneFragment = gql `
  fragment ContactPhoneFragment on ContactPhone {
    id
    type
    phone
    extension
    primary
    createdAt
    updatedAt
  }
`;
